import { render, staticRenderFns } from "./releaseCatalog.vue?vue&type=template&id=865786aa"
import script from "./releaseCatalog.vue?vue&type=script&lang=js"
export * from "./releaseCatalog.vue?vue&type=script&lang=js"
import style0 from "./releaseCatalog.vue?vue&type=style&index=0&id=865786aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports